<form *ngIf="applicant && formReady" class="form form-horizontal" #frm [formGroup]="form">
  <div class="row">
    <div class="col-md col-12">
      <div class="form-group">
        <label class="form-control-label" for="birthDate">Data Nascimento
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('birthDate').showIcon"
            [sourceText]="getOcrFieldSourceText('birthDate')"></app-admission-form-ocr-source-icon>
        </label>
        <input type="text" id="birthDate" [mask]="'00/00/0000'" [dropSpecialCharacters]="false"
          placeholder="dia/Mes/Ano" formControlName="birthDate" required class="form-control"
          [ngClass]="getOcrFieldState('birthDate').classes" />
        <app-error-msg [control]="form.controls['birthDate']" [label]="'birthDate'"> </app-error-msg>
      </div>
    </div>
    <div *ngIf="isFieldVisible('maritalStatus')" class="col-md col-12">
      <div class="form-group">
        <label class="form-control-label" for="maritalStatus">Estado Civil
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('maritalStatus').showIcon"
            [sourceText]="getOcrFieldSourceText('maritalStatus')"></app-admission-form-ocr-source-icon>
        </label>
        <ng-select id="maritalStatus" formControlName="maritalStatus" required placeholder="Estado Civil"
          [ngClass]="getOcrFieldState('maritalStatus').classes">
          <ng-option [value]="0">Selecione</ng-option>
          <ng-option [value]="1">Solteiro(a)</ng-option>
          <ng-option [value]="2">Casado(a)</ng-option>
          <ng-option [value]="3">Separado(a)</ng-option>
          <ng-option [value]="4">Divorciado(a)</ng-option>
          <ng-option [value]="5">Viúvo(a)</ng-option>
          <ng-option [value]="6">União estável</ng-option>
        </ng-select>
        <app-error-msg [control]="form.controls['maritalStatus']" [label]="'maritalStatus'"></app-error-msg>
      </div>
    </div>
    <div *ngIf="isFieldVisible('sex')" class="col-md col-12">
      <div class="form-group">
        <label class="form-control-label" for="gender">Sexo
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('sex').showIcon"
            [sourceText]="getOcrFieldSourceText('sex')"></app-admission-form-ocr-source-icon>
        </label>
        <ng-select id="gender" formControlName="sex" required placeholder="Sexo"
          [ngClass]="getOcrFieldState('sex').classes">
          <ng-option [value]="0">Selecione</ng-option>
          <ng-option [value]="1">Masculino</ng-option>
          <ng-option [value]="2">Feminino</ng-option>
          <ng-option [value]="3">Indefinido</ng-option>
        </ng-select>
        <app-error-msg [control]="form.controls['sex']" [label]="'sex'"> </app-error-msg>
      </div>
    </div>
    <div *ngIf="isFieldVisible('socialName')" class="col-md col-12">
      <div class="form-group">
        <label class="form-control-label" for="socialName">Nome Social
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('socialName').showIcon"
            [sourceText]="getOcrFieldSourceText('socialName')"></app-admission-form-ocr-source-icon>
        </label>
        <input type="text" id="socialName" maxlength="70" [dropSpecialCharacters]="false" (keypress)="omitChar($event)"
          [patterns]="pattern" [mask]="'B{70}'" formControlName="socialName" class="form-control"
          placeholder="Nome social" uppercase [ngClass]="getOcrFieldState('socialName').classes" />
        <app-error-msg [control]="form.controls['socialName']" [label]="'socialName'"></app-error-msg>
      </div>
    </div>
    <div *ngIf="isFieldVisible('dependentNumber')" class="col-md col-12">
      <div class="form-group">
        <label class="form-control-label" for="dependents">Numero de dependentes
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('dependentNumber').showIcon"
            [sourceText]="getOcrFieldSourceText('dependentNumber')"></app-admission-form-ocr-source-icon>
        </label>
        <input type="text" formControlName="dependentNumber" [mask]="'99'" id="dependents" required class="form-control"
          (change)="onChangeDependentNumber()" [ngClass]="getOcrFieldState('dependentNumber').classes" />
        <app-error-msg [control]="form.controls['dependentNumber']" [label]="'dependentNumber'">
        </app-error-msg>
      </div>
    </div>
  </div>
  <div class="row">
    <div *ngIf="isFieldVisible('stranger')" class="col-md-2 col-6">
      <div class="custom-control custom-switch">
        <p class="form-control-label mb-50">Estrangeiro</p>
        <input type="checkbox" class="custom-control-input" id="stranger" formControlName="stranger"
          [ngClass]="getOcrFieldState('stranger').classes" />
        <label class="form-control-label" class="custom-control-label" for="stranger">
          <span class="switch-icon-left"><i data-feather="check"></i></span>
          <span class="switch-icon-right"><i data-feather="x"></i></span>
        </label>
      </div>
    </div>
    <div *ngIf="isFieldVisible('nationality')" class="col-md-4 col-12">
      <div class="form-group">
        <label class="form-control-label" for="nationality">Nacionalidade
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('nationality').showIcon"
            [sourceText]="getOcrFieldSourceText('nationality')"></app-admission-form-ocr-source-icon>
        </label>
        <ng-select id="nationality" required formControlName="nationality"
          [ngClass]="getOcrFieldState('nationality').classes">
          <ng-option *ngFor="let country of countries" [value]="country.name">{{country.name}}</ng-option>
        </ng-select>
        <app-error-msg [control]="form.controls['nationality']" [label]="'nationality'"> </app-error-msg>
      </div>
    </div>
    <div *ngIf="isFieldVisible('birthState')" class="col-md-2 col-12">
      <div class="form-group">
        <label class="form-control-label" for="uf">UF de Origem
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('birthState').showIcon"
            [sourceText]="getOcrFieldSourceText('birthState')"></app-admission-form-ocr-source-icon>
        </label>
        <ng-select *ngIf="!isStranger" id="uf" required formControlName="birthState"
          [ngClass]="getOcrFieldState('birthState').classes">
          <ng-option *ngFor="let uf of states" [value]="uf.acronym">{{uf.acronym}}</ng-option>
        </ng-select>
        <input *ngIf="isStranger" type="text" maxlength="10" formControlName="birthState" class="form-control"
          [ngClass]="getOcrFieldState('birthState').classes" />
        <app-error-msg [control]="form.controls['birthState']" [label]="'birthState'"> </app-error-msg>
      </div>
    </div>
    <div class="col-md-4 col-12"> <!--mandatário, sempre visível e obrigatório-->
      <div class="form-group">
        <label class="form-control-label" for="birthplace">Naturalidade
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('birthplace').showIcon"
            [sourceText]="getOcrFieldSourceText('birthplace')"></app-admission-form-ocr-source-icon>
        </label>
        <ng-select *ngIf="!isStranger" [compareWith]="compareValues" [loading]="isLoading" formControlName="birthplace"
          placeholder="Selecione" [ngClass]="getOcrFieldState('birthplace').classes">
          <ng-option *ngFor="let place of places" [value]="place.name">{{place.name}}</ng-option>
        </ng-select>
        <input *ngIf="isStranger" type="text" maxlength="30" formControlName="birthplace" class="form-control"
          [ngClass]="getOcrFieldState('birthplace').classes" />
        <app-error-msg [control]="form.controls['birthplace']" [label]="'birthplace'"> </app-error-msg>
      </div>
    </div>
    <div *ngIf="isFieldVisible('racialDistinction')" class="col-md-2 col-12">
      <div class="form-group">
        <label class="form-control-label" for="racialDistinction">Raça/Cor
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('racialDistinction').showIcon"
            [sourceText]="getOcrFieldSourceText('racialDistinction')"></app-admission-form-ocr-source-icon>
        </label>
        <ng-select id="racialDistinction" formControlName="racialDistinction" placeholder="Raça/Cor"
          [ngClass]="getOcrFieldState('racialDistinction').classes">
          <ng-option [value]="1">Indígena</ng-option>
          <ng-option [value]="2">Branca</ng-option>
          <ng-option [value]="4">Preta</ng-option>
          <ng-option [value]="6">Amarela</ng-option>
          <ng-option [value]="8">Parda</ng-option>
          <ng-option [value]="9">Não Informado</ng-option>
          <ng-option [value]="0">Anonimizado</ng-option>
        </ng-select>
        <app-error-msg [control]="form.controls['racialDistinction']" [label]="'racialDistinction'">
        </app-error-msg>
      </div>
    </div>
    <div *ngIf="isFieldVisible('schooling')" class="col-md-4 col-12">
      <div class="form-group">
        <label class="form-control-label" for="schooling">Escolaridade
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('schooling').showIcon"
            [sourceText]="getOcrFieldSourceText('schooling')"></app-admission-form-ocr-source-icon>
        </label>
        <ng-select id="schooling" formControlName="schooling" placeholder="Escolaridade"
          [ngClass]="getOcrFieldState('schooling').classes">
          <ng-option *ngFor="let option of schoolingOptions" [value]="option.value">{{option.label}}</ng-option>
        </ng-select>
        <app-error-msg [control]="form.controls['schooling']" [label]="'schooling'">
        </app-error-msg>
      </div>
    </div>
    <div class="col-md-3 col-12"> <!--mandatário, sempre visível e obrigatório-->
      <div class="form-group">
        <label class="form-control-label" for="mothersName">Nome Mãe
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('mothersName').showIcon"
            [sourceText]="getOcrFieldSourceText('mothersName')"></app-admission-form-ocr-source-icon>
        </label>
        <input type="text" [dropSpecialCharacters]="false" (keypress)="omitChar($event)" [patterns]="pattern"
          [mask]="'B{100}'" formControlName="mothersName" name="mothersName" id="mothersName" class="form-control"
          placeholder="Nome mãe" uppercase [ngClass]="getOcrFieldState('mothersName').classes" />
        <app-error-msg [control]="form.controls['mothersName']" [label]="'mothersName'">
        </app-error-msg>
      </div>
    </div>
    <div *ngIf="isFieldVisible('fathersName')" class="col-md-3 col-12">
      <div class="form-group">
        <label class="form-control-label" for="fathersName">Nome Pai
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('fathersName').showIcon"
            [sourceText]="getOcrFieldSourceText('fathersName')"></app-admission-form-ocr-source-icon>
        </label>
        <input type="text" [dropSpecialCharacters]="false" (keypress)="omitChar($event)" [patterns]="pattern"
          [mask]="'B{100}'" name="fathersName" formControlName="fathersName" class="form-control"
          placeholder="Caso não tenha deixar em branco" uppercase [ngClass]="getOcrFieldState('fathersName').classes" />
        <app-error-msg [control]="form.controls['fathersName']" [label]="'fathersName'">
        </app-error-msg>
      </div>
    </div>
    <div *ngIf="isFieldVisible('bankNumber')" class="col-md-3 col-12">
      <div class="form-group">
        <label class="form-control-label" for="bankNumber">Banco
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('bankNumber').showIcon"
            [sourceText]="getOcrFieldSourceText('bankNumber')"></app-admission-form-ocr-source-icon>
        </label>
        <ng-select [compareWith]="compareValues" formControlName="bankNumber" placeholder="Selecione"
          [ngClass]="getOcrFieldState('bankNumber').classes">
          <ng-option *ngFor="let bank of bankOptions" [value]="bank.value">{{bank.label}}</ng-option>
        </ng-select>
        <app-error-msg [control]="form.controls['bankNumber']" [label]="'bankNumber'"> </app-error-msg>
      </div>
    </div>
    <div *ngIf="isFieldVisible('bankAgency')" class="col-md-3 col-12">
      <div class="form-group">
        <label class="form-control-label" for="bankAgency">Agência
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('bankAgency').showIcon"
            [sourceText]="getOcrFieldSourceText('bankAgency')"></app-admission-form-ocr-source-icon>
        </label>
        <input type="text" name="bankAgency" formControlName="bankAgency" class="form-control"
          (keypress)="omitChar($event)" placeholder="00000" [mask]="'99999'"
          [ngClass]="getOcrFieldState('bankAgency').classes" />
        <app-error-msg [control]="form.controls['bankAgency']" [label]="'bankAgency'">
        </app-error-msg>
      </div>
    </div>
    <div *ngIf="isFieldVisible('bankAccountNumber')" class="col-md-3 col-12">
      <div class="form-group">
        <label class="form-control-label" for="bank">Conta
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('bankAccountNumber').showIcon"
            [sourceText]="getOcrFieldSourceText('bankAccountNumber')"></app-admission-form-ocr-source-icon>
        </label>
        <input type="text" name="bankAccountNumber" formControlName="bankAccountNumber" class="form-control"
          (keypress)="omitChar($event)" placeholder="00000000" [mask]="'999999999999'"
          [ngClass]="getOcrFieldState('bankAccountNumber').classes">
        <app-error-msg [control]="form.controls['bankAccountNumber']" [label]="'bankAccountNumber'">
        </app-error-msg>
      </div>
    </div>
    <div *ngIf="isFieldVisible('bankAccountDigit')" class="col-md-3 col-12">
      <div class="form-group">
        <label class="form-control-label" for="bank">Dígito
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('bankAccountDigit').showIcon"
            [sourceText]="getOcrFieldSourceText('bankAccountDigit')"></app-admission-form-ocr-source-icon>
        </label>
        <input type="text" name="bankAccountDigit" formControlName="bankAccountDigit" class="form-control"
          (keypress)="omitChar($event)" placeholder="0" [mask]="'9'"
          [ngClass]="getOcrFieldState('bankAccountDigit').classes">
        <app-error-msg [control]="form.controls['bankAccountDigit']" [label]="'bankAccountDigit'">
        </app-error-msg>
      </div>
    </div>
  </div>
  <div class="divider divider-primary">
    <div class="divider-text">Endereço</div>
  </div>
  <div class="row">
    <div *ngIf="isFieldVisible('zipCode')" class="col-md-2 col-12">
      <div class="form-group">
        <label class="form-control-label" for="zipCode">Cep
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('zipCode').showIcon"
            [sourceText]="getOcrFieldSourceText('zipCode')"></app-admission-form-ocr-source-icon>
        </label>
        <input type="text" [dropSpecialCharacters]="true" (keypress)="omitChar($event)" [mask]="'00000-000'"
          formControlName="zipCode" name="zipCode" id="zipCode" class="form-control" placeholder="CEP"
          [ngClass]="getOcrFieldState('zipCode').classes" />
        <app-error-msg [control]="form.controls['zipCode']" [label]="'zipCode'"> </app-error-msg>
      </div>
    </div>
    <div *ngIf="isFieldVisible('streetType')" class="col-md-2 col-12">
      <div class="form-group">
        <label class="form-control-label">Tipo Logradouro
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('streetType').showIcon"
            [sourceText]="getOcrFieldSourceText('streetType')"></app-admission-form-ocr-source-icon>
        </label>
        <ng-select formControlName="streetType" placeholder="Tipo Logradouro"
          [ngClass]="getOcrFieldState('streetType').classes">
          <ng-option *ngFor="let option of streetTypeOptions" [value]="option.value">{{option.label}}</ng-option>
        </ng-select>
        <app-error-msg [control]="form.controls['streetType']" [label]="'streetType'"> </app-error-msg>
      </div>
    </div>
    <div *ngIf="isFieldVisible('street')" class="col-md-3 col-12">
      <div class="form-group">
        <label class="form-control-label">Rua
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('street').showIcon"
            [sourceText]="getOcrFieldSourceText('street')"></app-admission-form-ocr-source-icon>
        </label>
        <input class="form-control" formControlName="street" placeholder="Rua ABC XYZ" uppercase
          [dropSpecialCharacters]="false" (keypress)="omitChar($event)" [patterns]="numberPattern" [mask]="'C{40}'"
          [ngClass]="getOcrFieldState('street').classes" />
        <app-error-msg [control]="form.controls['street']" [label]="'street'"> </app-error-msg>
      </div>
    </div>
    <div *ngIf="isFieldVisible('addressComplement')" class="col-md-5 col-12">
      <div class="form-group">
        <label class="form-control-label">Complemento
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('addressComplement').showIcon"
            [sourceText]="getOcrFieldSourceText('addressComplement')"></app-admission-form-ocr-source-icon>
        </label>
        <input class="form-control" formControlName="addressComplement" placeholder="BLOCO E AP 202" uppercase
          [dropSpecialCharacters]="false" (keypress)="omitChar($event)" [patterns]="numberPattern" [mask]="'C{80}'"
          [ngClass]="getOcrFieldState('addressComplement').classes" />
        <app-error-msg [control]="form.controls['addressComplement']" [label]="'addressComplement'">
        </app-error-msg>
      </div>
    </div>
    <div *ngIf="isFieldVisible('houseNumber')" class="col-md-2 col-12">
      <div class="form-group">
        <label class="form-control-label">Número
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('houseNumber').showIcon"
            [sourceText]="getOcrFieldSourceText('houseNumber')"></app-admission-form-ocr-source-icon>
        </label>
        <input class="form-control" formControlName="houseNumber" placeholder="XXX" [dropSpecialCharacters]="false"
          (keypress)="omitChar($event)" [mask]="'999999'" [ngClass]="getOcrFieldState('houseNumber').classes" />
        <app-error-msg [control]="form.controls['houseNumber']" [label]="'houseNumber'">
        </app-error-msg>
      </div>
    </div>
    <div *ngIf="isFieldVisible('neighborhood')" class="col-md-4 col-12">
      <div class="form-group">
        <label class="form-control-label">Bairro
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('neighborhood').showIcon"
            [sourceText]="getOcrFieldSourceText('neighborhood')"></app-admission-form-ocr-source-icon>
        </label>
        <input class="form-control" formControlName="neighborhood" placeholder="Bairro" uppercase
          [dropSpecialCharacters]="false" (keypress)="omitChar($event)" [patterns]="pattern" [mask]="'B{40}'"
          [ngClass]="getOcrFieldState('neighborhood').classes" />
        <app-error-msg [control]="form.controls['neighborhood']" [label]="'neighborhood'">
        </app-error-msg>
      </div>
    </div>
    <div *ngIf="isFieldVisible('city')" class="col-md-4 col-12">
      <div class="form-group">
        <label class="form-control-label">Cidade
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('city').showIcon"
            [sourceText]="getOcrFieldSourceText('city')"></app-admission-form-ocr-source-icon>
        </label>
        <input class="form-control" formControlName="city" placeholder="Cidade" uppercase
          [dropSpecialCharacters]="false" (keypress)="omitChar($event)" [patterns]="pattern" [mask]="'B{40}'"
          [ngClass]="getOcrFieldState('city').classes" />
        <app-error-msg [control]="form.controls['city']" [label]="'city'"> </app-error-msg>
      </div>
    </div>
    <div *ngIf="isFieldVisible('state')" class="col-md-2 col-12">
      <div class="form-group">
        <label class="form-control-label">Estado
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('state').showIcon"
            [sourceText]="getOcrFieldSourceText('state')"></app-admission-form-ocr-source-icon>
        </label>
        <ng-select formControlName="state" required placeholder="Estado" [ngClass]="getOcrFieldState('state').classes">
          <ng-option *ngFor="let uf of states" [value]="uf.acronym">{{uf.acronym}}</ng-option>
        </ng-select>
        <app-error-msg [control]="form.controls['state']" [label]="'state'"> </app-error-msg>
      </div>
    </div>
  </div>
  <div class="divider divider-primary">
    <div class="divider-text">Contato</div>
  </div>
  <div class="row">
    <div [ngClass]="{
        'col-md-4': isFieldVisible('emergencyContact') && !isFieldVisible('emergencyName') && !isFieldVisible('emergencyKinship') && !isFieldVisible('emergencyEmail'),
        'col-md-6': !(isFieldVisible('emergencyContact') && !isFieldVisible('emergencyName') && !isFieldVisible('emergencyKinship') && !isFieldVisible('emergencyEmail'))
      }" class="col-12"> <!--mandatário, sempre visível e obrigatório-->
      <div class="form-group">
        <label class="form-control-label">Email
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('email').showIcon"
            [sourceText]="getOcrFieldSourceText('email')"></app-admission-form-ocr-source-icon>
        </label>
        <input class="form-control" formControlName="email" placeholder="email@mail.com"
          [ngClass]="getOcrFieldState('email').classes" />
        <app-error-msg [control]="form.controls['email']" [label]="'email'"> </app-error-msg>
      </div>
    </div>
    <div [ngClass]="{
        'col-md-4': isFieldVisible('emergencyContact') && !isFieldVisible('emergencyName') && !isFieldVisible('emergencyKinship') && !isFieldVisible('emergencyEmail'),
        'col-md-6': !(isFieldVisible('emergencyContact') && !isFieldVisible('emergencyName') && !isFieldVisible('emergencyKinship') && !isFieldVisible('emergencyEmail'))
      }" class="col-12"> <!--mandatário, sempre visível e obrigatório-->
      <div class="form-group">
        <label class="form-control-label">Contato (Principal)
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('contact1').showIcon"
            [sourceText]="getOcrFieldSourceText('contact1')"></app-admission-form-ocr-source-icon>
        </label>
        <input class="form-control" formControlName="contact1" [mask]="'(00) 0000-0000||(00) 0 0000-0000' "
          placeholder="(XX) X XXXX-XXXX" [ngClass]="getOcrFieldState('contact1').classes" />
        <app-error-msg [control]="form.controls['contact1']" [label]="'contact1'"> </app-error-msg>
      </div>
    </div>
    <div
      *ngIf="isFieldVisible('emergencyContact') && !isFieldVisible('emergencyName') && !isFieldVisible('emergencyKinship') && !isFieldVisible('emergencyEmail')"
      class="col-md-4 col-12">
      <div class="form-group">
        <label class="form-control-label">Contato (Emergência)
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('emergencyContact').showIcon"
            [sourceText]="getOcrFieldSourceText('emergencyContact')"></app-admission-form-ocr-source-icon>
        </label>
        <input class="form-control" formControlName="emergencyContact" [mask]="'(00) 0000-0000||(00) 0 0000-0000'"
          placeholder="(XX) X XXXX-XXXX" [ngClass]="getOcrFieldState('emergencyContact').classes" />
        <app-error-msg [control]="form.controls['emergencyContact']" [label]="'emergencyContact'"> </app-error-msg>
      </div>
    </div>
  </div>
  <div
    *ngIf="isFieldVisible('emergencyName') || isFieldVisible('emergencyKinship') || isFieldVisible('emergencyEmail')">
    <div class="divider divider-primary mt-2">
      <div class="divider-text">Contato de Emergência</div>
    </div>
    <div class="row">
      <div *ngIf="isFieldVisible('emergencyContact')" class="col-md-6 col-12">
        <div class="form-group">
          <label class="form-control-label">Contato (Emergência)
            <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('emergencyContact').showIcon"
              [sourceText]="getOcrFieldSourceText('emergencyContact')"></app-admission-form-ocr-source-icon>
          </label>
          <input class="form-control" formControlName="emergencyContact" [mask]="'(00) 0000-0000||(00) 0 0000-0000' "
            placeholder="(XX) X XXXX-XXXX" [ngClass]="getOcrFieldState('emergencyContact').classes" />
          <app-error-msg [control]="form.controls['emergencyContact']" [label]="'emergencyContact'"> </app-error-msg>
        </div>
      </div>
      <div *ngIf="isFieldVisible('emergencyName')" class="col-md-6 col-12">
        <div class="form-group">
          <label class="form-control-label" for="emergencyName">Nome (Contato de Emergência)
            <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('emergencyName').showIcon"
              [sourceText]="getOcrFieldSourceText('emergencyName')"></app-admission-form-ocr-source-icon>
          </label>
          <input id="emergencyName" type="text" formControlName="emergencyName" placeholder="Nome Completo"
            class="form-control" (keypress)="omitChar($event)" [patterns]="pattern" [mask]="'B{100}'" uppercase
            [ngClass]="getOcrFieldState('emergencyName').classes" />
          <app-error-msg [control]="form.controls['emergencyName']" [label]="'emergencyName'"> </app-error-msg>
        </div>
      </div>
      <div *ngIf="isFieldVisible('emergencyKinship')" class="col-md-6 col-12">
        <div class="form-group">
          <label class="form-control-label" for="emergencyKinship">Parentesco (Contato de Emergência)
            <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('emergencyKinship').showIcon"
              [sourceText]="getOcrFieldSourceText('emergencyKinship')"></app-admission-form-ocr-source-icon>
          </label>
          <input id="emergencyKinship" type="text" formControlName="emergencyKinship" placeholder="ESPOSA"
            class="form-control" (keypress)="omitChar($event)" [patterns]="pattern" [mask]="'B{50}'" uppercase
            [ngClass]="getOcrFieldState('emergencyKinship').classes" />
          <app-error-msg [control]="form.controls['emergencyKinship']" [label]="'emergencyKinship'"> </app-error-msg>
        </div>
      </div>
      <div *ngIf="isFieldVisible('emergencyEmail')" class="col-md-6 col-12">
        <div class="form-group">
          <label class="form-control-label" for="emergencyEmail">Email (Contato de Emergência)
            <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('emergencyEmail').showIcon"
              [sourceText]="getOcrFieldSourceText('emergencyEmail')"></app-admission-form-ocr-source-icon>
          </label>
          <input id="emergencyEmail" type="text" formControlName="emergencyEmail" placeholder="email@mail.com"
            class="form-control" uppercase [ngClass]="getOcrFieldState('emergencyEmail').classes" />
          <app-error-msg [control]="form.controls['emergencyEmail']" [label]="'emergencyEmail'"> </app-error-msg>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="isFieldVisible('shirtSize') || isFieldVisible('pantsSize') || isFieldVisible('shoeSize')"
    class="divider divider-primary">
    <div class="divider-text">Fardamento</div>
  </div>
  <div class="row">
    <div *ngIf="isFieldVisible('shirtSize')" class="col-md-4 col-12">
      <div class="form-group">
        <label class="form-control-label" for="shirtSize">Tamanho Blusa
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('shirtSize').showIcon"
            [sourceText]="getOcrFieldSourceText('shirtSize')"></app-admission-form-ocr-source-icon>
        </label>
        <ng-select id="shirtSize" formControlName="shirtSize" placeholder="Selecionar"
          [ngClass]="getOcrFieldState('shirtSize').classes">
          <ng-option *ngFor="let size of shirtSizeOptions" [value]="size.value">{{size.label}}</ng-option>
        </ng-select>
        <app-error-msg [control]="form.controls['shirtSize']" [label]="'tamanho'"> </app-error-msg>
      </div>
    </div>
    <div *ngIf="isFieldVisible('pantsSize')" class="col-md-4 col-12">
      <div class="form-group">
        <label class="form-control-label" for="pantsSize">Tamanho Calça
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('pantsSize').showIcon"
            [sourceText]="getOcrFieldSourceText('pantsSize')"></app-admission-form-ocr-source-icon>
        </label>
        <input type="text" formControlName="pantsSize" placeholder="40" class="form-control"
          (keypress)="omitChar($event)" [mask]="'99'" [ngClass]="getOcrFieldState('pantsSize').classes" />
        <app-error-msg [control]="form.controls['pantsSize']" [label]="'pantsSize'"> </app-error-msg>
      </div>
    </div>
    <div *ngIf="isFieldVisible('shoeSize')" class="col-md-4 col-12">
      <div class="form-group">
        <label class="form-control-label" for="shoeSize">Número Calçado
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('shoeSize').showIcon"
            [sourceText]="getOcrFieldSourceText('shoeSize')"></app-admission-form-ocr-source-icon>
        </label>
        <input type="text" formControlName="shoeSize" placeholder="40" class="form-control"
          (keypress)="omitChar($event)" [mask]="'99'" [ngClass]="getOcrFieldState('shoeSize').classes" />
        <app-error-msg [control]="form.controls['shoeSize']" [label]="'shoeSize'"> </app-error-msg>
      </div>
    </div>
  </div>
  <div class="divider divider-primary">
    <div class="divider-text">Documentação</div>
  </div>
  <div class="row">
    <div *ngIf="isFieldVisible('electoralCard')" class="col-md-4 col-12">
      <div class="form-group">
        <label class="form-control-label" for="electoralCard">Título de Eleitor
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('electoralCard').showIcon"
            [sourceText]="getOcrFieldSourceText('electoralCard')"></app-admission-form-ocr-source-icon>
        </label>
        <input type="text" formControlName="electoralCard" [mask]="'9{14}'" name="electoralCard" id="electoralCard"
          class="form-control" placeholder="Título de Eleitor" [ngClass]="getOcrFieldState('electoralCard').classes" />
        <app-error-msg [control]="form.controls['electoralCard']" [label]="'electoralCard'"> </app-error-msg>
      </div>
    </div>
    <div *ngIf="isFieldVisible('electoralSection')" class="col-md-4 col-12">
      <div class="form-group">
        <label class="form-control-label" for="electoralSection">Seção
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('electoralSection').showIcon"
            [sourceText]="getOcrFieldSourceText('electoralSection')"></app-admission-form-ocr-source-icon>
        </label>
        <input type="text" formControlName="electoralSection" [mask]="'9{4}'" name="electoralSection"
          id="electoralSection" class="form-control" placeholder="Seção de Votação"
          [ngClass]="getOcrFieldState('electoralSection').classes" />
        <app-error-msg [control]="form.controls['electoralSection']" [label]="'electoralSection'"> </app-error-msg>
      </div>
    </div>
    <div class="col-md-4 col-12">
      <div *ngIf="isFieldVisible('electoralZone')" class="form-group">
        <label class="form-control-label" for="electoralZone">Zona Eleitoral
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('electoralZone').showIcon"
            [sourceText]="getOcrFieldSourceText('electoralZone')"></app-admission-form-ocr-source-icon>
        </label>
        <input type="text" formControlName="electoralZone" [mask]="'9{4}'" name="electoralZone" id="electoralZone"
          class="form-control" placeholder="Zona Eleitoral" [ngClass]="getOcrFieldState('electoralZone').classes" />
        <app-error-msg [control]="form.controls['electoralZone']" [label]="'electoralZone'"> </app-error-msg>
      </div>
    </div>
    <div class="col-md-4 col-12"> <!--mandatário, sempre visível e obrigatório-->
      <div class="form-group">
        <label class="form-control-label" for="rg">RG
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('rg').showIcon"
            [sourceText]="getOcrFieldSourceText('rg')"></app-admission-form-ocr-source-icon>
        </label>
        <input type="text" formControlName="rg" [mask]="'999999999A99999||999999999-A'" name="rg" id="rg"
          class="form-control" placeholder="RG" [ngClass]="getOcrFieldState('rg').classes" />
        <app-error-msg [control]="form.controls['rg']" [label]="'rg'"> </app-error-msg>
      </div>
    </div>
    <div *ngIf="isFieldVisible('rgIssuer')" class="col-md-4 col-6">
      <div class="form-group">
        <label class="form-control-label" for="rgIssuer">Orgão Emissor
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('rgIssuer').showIcon"
            [sourceText]="getOcrFieldSourceText('rgIssuer')"></app-admission-form-ocr-source-icon>
        </label>
        <input type="text" formControlName="rgIssuer" (keypress)="omitChar($event)" [patterns]="pattern" [mask]="'B{8}'"
          name="rgIssuer" id="rgIssuer" class="form-control" placeholder="SSP" uppercase
          [ngClass]="getOcrFieldState('rgIssuer').classes" />
        <app-error-msg [control]="form.controls['rgIssuer']" [label]="'rgIssuer'"> </app-error-msg>
      </div>
    </div>
    <div *ngIf="isFieldVisible('rgState')" class="col-md-4 col-6">
      <div class="form-group">
        <label class="form-control-label" for="rgUf">UF
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('rgState').showIcon"
            [sourceText]="getOcrFieldSourceText('rgState')"></app-admission-form-ocr-source-icon>
        </label>
        <ng-select formControlName="rgState" required placeholder="UF" [ngClass]="getOcrFieldState('rgState').classes">
          <ng-option *ngFor="let uf of states" [value]="uf.acronym">{{uf.acronym}}</ng-option>
        </ng-select>
        <app-error-msg [control]="form.controls['rgState']" [label]="'rgState'"> </app-error-msg>
      </div>
    </div>
    <div *ngIf="isFieldVisible('rgDate')" class="col-md-4 col-12">
      <div class="form-group">
        <label class="form-control-label" for="rgDate">Data Emissão RG
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('rgDate').showIcon"
            [sourceText]="getOcrFieldSourceText('rgDate')"></app-admission-form-ocr-source-icon>
        </label>
        <input type="text" [mask]="'00/00/0000'" [dropSpecialCharacters]="false" placeholder="dia/Mes/Ano"
          formControlName="rgDate" name="rgDate" id="rgDate" class="form-control"
          [ngClass]="getOcrFieldState('rgDate').classes" />
        <app-error-msg [control]="form.controls['rgDate']" [label]="'rgDate'"> </app-error-msg>
      </div>
    </div>
    <div *ngIf="isFieldVisible('pis')" class="col-md-4 col-12">
      <div class="form-group">
        <label class="form-control-label" for="pis">PIS
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('pis').showIcon"
            [sourceText]="getOcrFieldSourceText('pis')"></app-admission-form-ocr-source-icon>
        </label>
        <input type="text" formControlName="pis" [mask]="'000.00000.00-0||000.00000.00'" name="pis" id="pis"
          class="form-control" placeholder="PIS" [ngClass]="getOcrFieldState('pis').classes" />
        <app-error-msg [control]="form.controls['pis']" [label]="'pis'"> </app-error-msg>
      </div>
    </div>
    <div *ngIf="isFieldVisible('ctpsNumber')" class="col-md-4 col-12">
      <div class="form-group">
        <span [data-feather]="'info'"></span>
        <label class="form-control-label" class="form-control-label pointer" for="ctpsNumber"
          popoverTitle="CTPS DIGITAL" ngbPopover="Se CTPS Digital, informar 7 primeiros dígitos do CPF"
          triggers="click:blur">&nbsp;Nº CTPS
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('ctpsNumber').showIcon"
            [sourceText]="getOcrFieldSourceText('ctpsNumber')"></app-admission-form-ocr-source-icon>
        </label>
        <input type="text" formControlName="ctpsNumber" [mask]="'0000000'" name="ctpsNumber" id="ctpsNumber"
          class="form-control" placeholder="0000000" [ngClass]="getOcrFieldState('ctpsNumber').classes" />
        <app-error-msg [control]="form.controls['ctpsNumber']" [label]="'ctpsNumber'"> </app-error-msg>
      </div>
    </div>
    <div *ngIf="isFieldVisible('ctpsSerie')" class="col-md-4 col-6">
      <div class="form-group">
        <span [data-feather]="'info'"></span>
        <label class="form-control-label" class="form-control-label pointer" for="ctpsSerie" popoverTitle="CTPS DIGITAL"
          ngbPopover="Se CTPS Digital, informar 4 últimos dígitos do CPF" triggers="click:blur">&nbsp;Série CTPS
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('ctpsSerie').showIcon"
            [sourceText]="getOcrFieldSourceText('ctpsSerie')"></app-admission-form-ocr-source-icon>
        </label>
        <input type="text" formControlName="ctpsSerie" [mask]="'0000'" name="ctpsSerie" id="ctpsSerie"
          class="form-control" placeholder="0000" [ngClass]="getOcrFieldState('ctpsSerie').classes" />
        <app-error-msg [control]="form.controls['ctpsSerie']" [label]="'ctpsSerie'"> </app-error-msg>
      </div>
    </div>
    <div *ngIf="isFieldVisible('ctpsState')" class="col-md-4 col-6">
      <div class="form-group">
        <label class="form-control-label" for="ctpsState">UF CTPS
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('ctpsState').showIcon"
            [sourceText]="getOcrFieldSourceText('ctpsState')"></app-admission-form-ocr-source-icon>
        </label>
        <ng-select formControlName="ctpsState" required placeholder="UF CTPS"
          [ngClass]="getOcrFieldState('ctpsState').classes">
          <ng-option *ngFor="let uf of states" [value]="uf.acronym">{{uf.acronym}}</ng-option>
        </ng-select>
        <app-error-msg [control]="form.controls['ctpsState']" [label]="'ctpsState'"> </app-error-msg>
      </div>
    </div>
    <div *ngIf="isFieldVisible('ctpsIssueDate')" class="col-md-4 col-6">
      <div class="form-group">
        <label class="form-control-label" for="ctpsIssueDate">Data Emissão CTPS
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('ctpsIssueDate').showIcon"
            [sourceText]="getOcrFieldSourceText('ctpsIssueDate')"></app-admission-form-ocr-source-icon>
        </label>
        <input type="text" [mask]="'00/00/0000'" [dropSpecialCharacters]="false" placeholder="dia/Mes/Ano"
          formControlName="ctpsIssueDate" name="ctpsIssueDate" id="ctpsIssueDate" class="form-control"
          [ngClass]="getOcrFieldState('ctpsIssueDate').classes" />
        <app-error-msg [control]="form.controls['ctpsIssueDate']" [label]="'ctpsIssueDate'"> </app-error-msg>
      </div>
    </div>
    <div class="col-md-4 col-6">
      <div class="form-group">
        <span [data-feather]="'info'"></span>
        <label class="form-control-label" class="form-control-label pointer" for="cpf" popoverTitle="PARA CONFERIR"
          ngbPopover="Caso haja divergência no CPF informado, favor comunicar ao RH." triggers="click:blur">&nbsp;CPF
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('cpf').showIcon"
            [sourceText]="getOcrFieldSourceText('cpf')"></app-admission-form-ocr-source-icon>
        </label>
        <input type="text" formControlName="cpf" [mask]="'000.000.000-00'" name="cpf" id="cpf" class="form-control"
          [ngClass]="getOcrFieldState('cpf').classes" />
      </div>
    </div>
    <div *ngIf="this.applicant.sex == 1 && isFieldVisible('militaryDischarge')" class="col-md-4 col-6">
      <div class="form-group">
        <label class="form-control-label" for="militaryDischarge">Reservista
          <app-admission-form-ocr-source-icon [visible]="getOcrFieldState('militaryDischarge').showIcon"
            [sourceText]="getOcrFieldSourceText('militaryDischarge')"></app-admission-form-ocr-source-icon>
        </label>
        <input type="text" formControlName="militaryDischarge" [mask]="'00.000.000000.0'" name="militaryDischarge"
          id="militaryDischarge" class="form-control" placeholder="Certificado de Dispensa Militar"
          [ngClass]="getOcrFieldState('militaryDischarge').classes" />
        <app-error-msg [control]="form.controls['militaryDischarge']" [label]="'militaryDischarge'"> </app-error-msg>
      </div>
    </div>
  </div>
</form>
<div *ngIf="dependentNumber > 0" [formGroup]="dependentsform" class="form form-horizontal">
  <ng-container *ngIf="dependentsFrmArray.controls.length > 0" formArrayName="dependents">
    <ng-container *ngFor="let dependentForm of dependentsFrmArray.controls; let i = index">
      <div *ngIf="dependentNumber > 0" class="divider divider-primary">
        <div class="divider-text">Dependente - {{ dependentForm.get('name')?.value }}</div>
      </div>
      <div [formGroup]="dependentForm" class="row">
        <div *ngIf="isFieldVisible('name')" class="col-md-4 col-12">
          <div class="form-group">
            <label class="form-control-label" for="name">Nome
              <app-admission-form-ocr-source-icon
                [visible]="getOcrFieldState('name', false, dependentForm.get('id')?.value, dependentForm.get('name')?.value).showIcon"
                [sourceText]="getOcrFieldSourceText('name', false, dependentForm.get('id')?.value)"></app-admission-form-ocr-source-icon>
            </label>
            <input type="text" [dropSpecialCharacters]="false" (keypress)="omitChar($event)" [patterns]="pattern"
              [mask]="'B{100}'" class="form-control" formControlName="name" required placeholder="Nome" uppercase
              [ngClass]="getOcrFieldState('name', false, dependentForm.get('id')?.value, dependentForm.get('name')?.value).classes" />
            <app-error-msg [control]="dependentForm.controls['name']" [label]="'name'">
            </app-error-msg>
          </div>
        </div>
        <div class="col-md-4 col-12">
          <div class="form-group">
            <label class="form-control-label" for="birthDate">Data Nascimento
              <app-admission-form-ocr-source-icon
                [visible]="getOcrFieldState('birthDate', false, dependentForm.get('id')?.value, dependentForm.get('birthDate')?.value).showIcon"
                [sourceText]="getOcrFieldSourceText('birthDate', false, dependentForm.get('id')?.value)"></app-admission-form-ocr-source-icon>
            </label>
            <input type="text" [mask]="'00/00/0000'" [dropSpecialCharacters]="false" placeholder="dia/Mes/Ano"
              formControlName="birthDate" required class="form-control"
              [ngClass]="getOcrFieldState('birthDate', false, dependentForm.get('id')?.value, dependentForm.get('birthDate')?.value).classes" />
            <app-error-msg [control]="dependentForm.controls['birthDate']" [label]="'nascimento'">
            </app-error-msg>
          </div>
        </div>
        <div class="col-md-4 col-12">
          <div class="form-group">
            <label class="form-control-label" for="kinshipDegree">Grau de Parentesco
              <app-admission-form-ocr-source-icon
                [visible]="getOcrFieldState('kinshipDegree', false, dependentForm.get('id')?.value, dependentForm.get('kinshipDegree')?.value).showIcon"
                [sourceText]="getOcrFieldSourceText('kinshipDegree', false, dependentForm.get('id')?.value)"></app-admission-form-ocr-source-icon>
            </label>
            <ng-select id="kinshipDegree" formControlName="kinshipDegree" required placeholder="Grau de Parentesco"
              [ngClass]="getOcrFieldState('kinshipDegree', false, dependentForm.get('id')?.value, dependentForm.get('kinshipDegree')?.value).classes">
              <ng-option [value]="'C'">Cônjuge/Companheiro</ng-option>
              <ng-option [value]="'F'">Filho</ng-option>
              <ng-option [value]="'E'">Enteado</ng-option>
              <ng-option [value]="'P'">Pai/Mãe</ng-option>
              <ng-option [value]="'O'">Agregado/Outros</ng-option>
            </ng-select>
            <app-error-msg [control]="dependentForm.controls['kinshipDegree']" [label]="'grau'">
            </app-error-msg>
          </div>
        </div>
        <div class="col-md-4 col-12">
          <div class="form-group">
            <label class="form-control-label" for="sex">Sexo
              <app-admission-form-ocr-source-icon
                [visible]="getOcrFieldState('sex', false, dependentForm.get('id')?.value, dependentForm.get('sex')?.value).showIcon"
                [sourceText]="getOcrFieldSourceText('sex', false, dependentForm.get('id')?.value)"></app-admission-form-ocr-source-icon>
            </label>
            <ng-select id="gender" formControlName="sex" required placeholder="Sexo"
              [ngClass]="getOcrFieldState('sex', false, dependentForm.get('id')?.value, dependentForm.get('sex')?.value).classes">
              <ng-option [value]="0">Selecione</ng-option>
              <ng-option [value]="1">Masculino</ng-option>
              <ng-option [value]="2">Feminino</ng-option>
              <ng-option [value]="3">Indefinido</ng-option>
            </ng-select>
            <app-error-msg [control]="dependentForm.controls['sex']" [label]="'sexo'">
            </app-error-msg>
          </div>
        </div>
        <div class="col-md-4 col-12">
          <div class="form-group">
            <label class="form-control-label" for="cpf">CPF
              <app-admission-form-ocr-source-icon
                [visible]="getOcrFieldState('cpf', false, dependentForm.get('id')?.value, dependentForm.get('cpf')?.value).showIcon"
                [sourceText]="getOcrFieldSourceText('cpf', false, dependentForm.get('id')?.value)"></app-admission-form-ocr-source-icon>
            </label>
            <input type="text" [mask]="'000.000.000-00'" class="form-control" required formControlName="cpf"
              placeholder="CPF"
              [ngClass]="getOcrFieldState('cpf', false, dependentForm.get('id')?.value, dependentForm.get('cpf')?.value).classes" />
            <app-error-msg [control]="dependentForm.controls['cpf']" [label]="'cpf'">
            </app-error-msg>
            <span *ngIf="dependentForm.get('cpf')?.errors?.duplicateCpf">
              <small class="form-text text-danger"> Mesmo CPF do candidato ou de outro dependente</small>
            </span>
          </div>
        </div>
        <div *ngIf="isFieldVisible('familySalaryType')" class="col-md-4 col-12">
          <div class="form-group">
            <label class="form-control-label" for="familySalaryType">Dependente de Salário Família
              <app-admission-form-ocr-source-icon
                [visible]="getOcrFieldState('familySalaryType', false, dependentForm.get('id')?.value, dependentForm.get('familySalaryType')?.value).showIcon"
                [sourceText]="getOcrFieldSourceText('familySalaryType', false, dependentForm.get('id')?.value)"></app-admission-form-ocr-source-icon>
            </label>
            <ng-select id="familySalaryType" formControlName="familySalaryType" placeholder="Selecionar"
              [ngClass]="getOcrFieldState('familySalaryType', false, dependentForm.get('id')?.value, dependentForm.get('familySalaryType')?.value).classes">
              <ng-option [value]="1">s/Lim.Idade</ng-option>
              <ng-option [value]="2">Ate 14 Anos</ng-option>
              <ng-option [value]="3">Não é Dependente</ng-option>
            </ng-select>
            <app-error-msg [control]="dependentForm.controls['familySalaryType']" [label]="'familia'">
            </app-error-msg>
          </div>
        </div>
        <div *ngIf="isFieldVisible('incomeReportType')" class="col-md-4 col-12">
          <div class="form-group">
            <label class="form-control-label" for="incomeReportType">Dependente de IR
              <app-admission-form-ocr-source-icon
                [visible]="getOcrFieldState('incomeReportType', false, dependentForm.get('id')?.value, dependentForm.get('incomeReportType')?.value).showIcon"
                [sourceText]="getOcrFieldSourceText('incomeReportType', false, dependentForm.get('id')?.value)"></app-admission-form-ocr-source-icon>
            </label>
            <ng-select id="incomeReportType" formControlName="incomeReportType" placeholder="Selecionar"
              [ngClass]="getOcrFieldState('incomeReportType', false, dependentForm.get('id')?.value, dependentForm.get('incomeReportType')?.value).classes">
              <ng-option [value]="1">s/Lim.Idade</ng-option>
              <ng-option [value]="2">Ate 21 Anos</ng-option>
              <ng-option [value]="3">Ate 24 Anos</ng-option>
              <ng-option [value]="4">Não é Dependente</ng-option>
            </ng-select>
            <app-error-msg [control]="dependentForm.controls['incomeReportType']" [label]="'IR'">
            </app-error-msg>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>